import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const HomePage = lazy(() => import('./HomePage'));

export const homeRoutes: AppRoute[] = [{ path: '/', name: 'Inicio', element: HomePage }];
